import React, { createContext, useContext, useEffect, useState } from "react";

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const [property, setPropertyState] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("tmn_property");
    if (stored) {
      try { setPropertyState(JSON.parse(stored)); } catch { /* ignore */ }
    }
  }, []);

  const setProperty = (p) => {
    if (p) {
      localStorage.setItem("tmn_property", JSON.stringify(p));
    } else {
      localStorage.removeItem("tmn_property");
    }
    setPropertyState(p);
  };

  return (
    <PropertyContext.Provider value={{ property, setProperty }}>
      {children}
    </PropertyContext.Provider>
  );
}

export const useProperty = () => useContext(PropertyContext);
